import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
function useModalState() {
  const $ = _c(5);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const openModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeModal = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const toggleModal = t2;
  let t3;
  if ($[3] !== isOpen) {
    t3 = {
      isOpen,
      openModal,
      closeModal,
      toggleModal
    };
    $[3] = isOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(prevState) {
  return !prevState;
}
export default useModalState;